/**
 * 邀请好友入群页懒加载壳（14.27c；GroupMembersLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function GroupInviteLazy({ groupId }: { groupId: number }) {
  const { mod } = useLazyModule(() => import('./GroupInvitePage'));
  if (mod === null) return <div data-testid="group-invite-loading-shell">加载中…</div>;
  return <mod.GroupInvitePage groupId={groupId} />;
}
